import { RouteObject } from 'react-router';
import App from './App';
import OAuth2PopupCallback from './components/auth/oauth2-popup-callback/OAuth2PopupCallback';
import { OAUTH2_POPUP_CALLBACK_PATH } from './components/auth/oauth2-popup-callback/oauth2PopupRoutes';
import SecureRoute from './components/auth/SecureRoute';
import SecureRouteReports from './components/auth/SecureRouteReports';
import CompareReportLines from './components/tables/compare-reports-table/CompareReportLines';
import ReportLines from './components/tables/report-lines-table/ReportLines';
import FilterableReportsTable from './components/tables/reports-table/FilterableReportsTable';

const SecureRouteApp = () => {
    return (
        <SecureRoute>
            <App />
        </SecureRoute>
    );
};

const SecureRouteReportLines = () => {
    return (
        <SecureRouteReports>
            <ReportLines />
        </SecureRouteReports>
    );
};

const SecureRouteCompareReportLines = () => {
    return (
        <SecureRouteReports>
            <CompareReportLines />
        </SecureRouteReports>
    );
};

const routesConfig: RouteObject[] = [
    {
        path: OAUTH2_POPUP_CALLBACK_PATH,
        Component: OAuth2PopupCallback,
    },
    {
        path: '/',
        Component: SecureRouteApp,
        children: [
            { path: '/', Component: FilterableReportsTable },
            { path: '/compare/:reportId/:versionId', Component: SecureRouteCompareReportLines },
            { path: '/view/:reportId', Component: SecureRouteReportLines },
            { path: '/view/:reportId/forms/:id', Component: SecureRouteReportLines },
            { path: '/view/:reportId/forms', Component: SecureRouteReportLines },
            { path: '/view/:reportId/comments', Component: SecureRouteReportLines },
            { path: '/view/:reportId/comments/:commentId', Component: SecureRouteReportLines },
            { path: '/view/:reportId/forms/:id/comments', Component: SecureRouteReportLines },
            { path: '/view/:reportId/forms/:id/comments/:commentId', Component: SecureRouteReportLines },
            { path: '/view/:reportId/cell/:columnId/:rowId/comments', Component: SecureRouteReportLines },
            { path: '/view/:reportId/cell/:columnId/:rowId/comments/:commentId', Component: SecureRouteReportLines },
            { path: '/view/:reportId/forms/:id/cell/:columnId/:rowId/comments', Component: SecureRouteReportLines },
            { path: '/view/:reportId/forms/:id/cell/:columnId/:rowId/comments/:commentId', Component: SecureRouteReportLines },
        ],
    },
];

export default routesConfig;
